import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledPopupDiv } from '../../atoms/popup/popup.styles';
import { StyledCurrentLocation } from '../currentLocation/currentLocation.styles';
import { StyledRecentListDiv } from '@marriott/mi-ui-library-shop';

export const StyledDestination = styled.div`
  ${rtl`
  position: relative;
  flex: 1;
  @media ${theme.mediaQuery.mobileOnly}{
    overflow-y: hidden;
  }
  input {
    padding: 0;
    border: 0;
    height: auto;
  }
  ${StyledPopupDiv} {
    &.search-page-destination-mobile-popup {
      .MuiAutocomplete-root{
        width: 100%;
        .MuiAutocomplete-inputRoot[class*='MuiInput-root']{
          padding-right: ${toRem(5)};
        }
      }
    }
    &.search-page-destination {
      ${StyledCurrentLocation}, ${StyledRecentListDiv} {
        @media ${theme.mediaQuery.desktop} {
          margin-left: 0;
          .icon-nearby {
            &:before {
              left: ${toRem(-27)};
            }
          }
        }
      }
      .MuiInputBase-formControl {
        padding-right: 0 !important;
        .MuiAutocomplete-endAdornment {
          color: ${theme.color['black']};
          .icon-cancel {
            color: ${theme.color['black']};
          }
        }
      }
      @media ${theme.mediaQuery.desktop} {
        // padding-left: ${toRem(18)} !important;
        left: 0;
        width: ${toRem(375)};
        &:not(.show-popup) {
          z-index:100;
          max-width: 100%;
          padding-right: ${toRem(20)};
        }
      }
      .with-input {
        @media ${theme.mediaQuery.desktop} {
          padding-left: 0;
        }
        @media ${theme.mediaQuery.tablet} {
          padding-top: ${toRem(25)};
        }
        .dashed-border {
          &:after {
            display: none;
          }
        }
      }
      @media ${theme.mediaQuery.allTablets} {
        &.show-popup {
          z-index:110;
          .with-input {
            padding-right: ${toRem(20)};
            .MuiAutocomplete-inputRoot[class*='MuiInput-root'] {
              padding-right: ${toRem(30)};
            }
          }
        }
      }
      @media ${theme.mediaQuery.desktop} {
        &.show-popup {
          z-index:100;
          .with-input {
            padding-right: ${toRem(20)};
            .MuiAutocomplete-inputRoot[class*='MuiInput-root'] {
              padding-right: ${toRem(35)};
            }
          }
        }
      }
    }
  }
  .t-font-m {
    @media ${theme.mediaQuery.mobileOnly} {
      color: ${theme.color['base-10']};
    }
  }
  button {
    @media ${theme.mediaQuery.tablet} {
      background-color: transparent;
      padding: 0;
      text-align: left;
    }
    @media ${theme.mediaQuery.mobileOnly} {
      background-color: transparent;
      padding: 0;
      text-align: left;
      border: none;
      padding-left: ${toRem(16)};
      padding-top: ${toRem(4)};
    }
  }

  /* Autocomplete input style  */
  .MuiFormControl-root {
    margin: 0;
  }
  .MuiAutocomplete-inputRoot[class*='MuiInput-root'] {
    padding: 0;
    @media ${theme.mediaQuery.ie11Only} {
      @media ${theme.mediaQuery.tablet} {
        padding-right: ${toRem(56)};
      }
    }
  }

  .MuiAutocomplete-inputRoot[class*='MuiInput-root'] .MuiAutocomplete-input:first-child {
    padding: 0;
  }

  .MuiAutocomplete-popupIndicator {
    display: none;
  }

  .MuiAutocomplete-endAdornment {
    position: relative;
    right: ${toRem(24)};
    top: calc(50% - 10px);
    .icon-cancel::before {
      color: ${theme.color['base-10']};
    }
  }

  .remove-icon{
        @media ${theme.mediaQuery.tablet}{
          visibility:hidden !important;
    }
    @media ${theme.mediaQuery.desktop}{
      visibility:hidden !important;
    }
  }
  .MuiAutocomplete-clearIndicator {
    padding: ${toRem(2)};
  }
  .MuiAutocomplete-root.dirty.focused .MuiAutocomplete-clearIndicator,
  MuiAutocomplete-root.dirty.focused.Mui-focused .MuiAutocomplete-clearIndicator,
  .MuiAutocomplete-root.dirty.focused:hover .MuiAutocomplete-clearIndicator {
    visibility: visible;
  }
  @media ${theme.mediaQuery.tablet}{
  .MuiAutocomplete-root.dirty:not(.focused):hover .MuiAutocomplete-clearIndicator {
    visibility: visible;
  }
}
@media ${theme.mediaQuery.desktop}{
  .MuiAutocomplete-root.dirty:not(.focused):hover .MuiAutocomplete-clearIndicator {
    visibility: visible;
  }
}

  .MuiInput-underline::before {
    transition: none;
    border-bottom: 0;
  }
  .MuiInput-underline:hover:not(.Mui-disabled)::before {
    border: 0;
  }
  .MuiInput-underline:after {
    transition: none;
    border-bottom: 0;
  }
  .show-border{
    .MuiInput-underline::after {
    border-bottom: ${toRem(3)} solid ${theme.color.black};
    }
  }
  .MuiInput-underline.Mui-focused::after {
    transform: scaleX(0);
  }
  legend {
    display: none;
  }
  .MuiAutocomplete-inputRoot[class*='MuiInput-root'] input[type='text'].MuiInputBase-input {
    box-sizing: border-box;
    padding: 0;
    border: none;
    height: auto;
    text-transform: capitalize;
    font-family: ${theme.fontFamily.swiss};
    line-height: ${theme.fonts['lineHeightXxl']};
    caret-color: ${theme.color['light-orange-2']};
    font-weight: 700;
    @media ${theme.mediaQuery.mobileOnly} {
      color: ${theme.color['white']};
      font-size: ${theme.fonts['fontL']};
      margin-right:${toRem(7)};
    }
    @media ${theme.mediaQuery.tablet} {
      font-size: ${theme.fonts['fontL']};
      line-height: ${theme.fonts['lineHeightL']};
    }
    @media ${theme.mediaQuery.desktop} {
      font-size: ${theme.fonts['fontXxl']};
      line-height: ${theme.fonts['lineHeightXxl']};
    }
    &:focus {
      border-bottom: 0;
    }
  }

  .MuiIconButton-root,
  .MuiIconButton-root:hover {
    color: ${theme.color.white};
  }
  .MuiSvgIcon-root {
    height: ${toRem(18)};
    width: ${toRem(18)};
  }

  .dashed-border {
    &:after {
      content: '';
      border-right: ${toRem(1)} dashed ${theme.color['dark-gray-6']};
      height: calc(100% - ${toRem(54)});
      position: absolute;
      right: ${toRem(-13)};
      top: ${toRem(28)};
      @media ${theme.mediaQuery.desktop} {
        top: ${toRem(27)};
      }
    }
  }
.current-loc-popup{
width:24rem;
overflow:hidden;
padding-left:0 !important;
}
  .show-popup {
    border-right: 0;
    margin: 0;
    padding: 0;
    z-index:100;
    @media ${theme.mediaQuery.tablet} {
      padding-bottom: 0;
      &:not(.dest-popup) {
        overflow: hidden;
      }
      & > div:first-child {
        position: sticky;
      }
      .show-popup-scrollable {
        ::-webkit-scrollbar {
          width: 0;
        }
        overflow: auto;
        max-height: ${toRem(480)};
      }
    }
    @media ${theme.mediaQuery.desktop} {
      padding: 0;
    }
    .with-input {
      cursor: auto;
      @media ${theme.mediaQuery.tablet} {
        padding: ${toRem(20)} ${toRem(24)} 0;
      }
      @media ${theme.mediaQuery.desktop} {
        padding: ${toRem(22)} ${toRem(32)} 0;
      }
      @media ${theme.mediaQuery.largeDesktop} {
        padding: ${toRem(22)} ${toRem(40)} 0;
      }
      &:hover {
        opacity: 1;
      }
      > div {
        border: 0;
      }

      label {
        @media ${theme.mediaQuery.tablet} {
          color: ${theme.color['light-gray-4']};
        }
        @media ${theme.mediaQuery.desktop} {
          padding-bottom: ${toRem(4)};
        }
      }
    }
    .MuiAutocomplete-inputRoot[class*='MuiInput-root'] {
      padding-bottom: ${toRem(18)};
    }
    .MuiAutocomplete-endAdornment {
      right: 0;
      top: calc(50% - 20px);
    }
    .MuiInput-underline::after {
      transform: scaleX(1);
    }

    /* autocomplete popper style */
    .MuiAutocomplete-popperDisablePortal {
      position: relative;
    }
    .MuiAutocomplete-noOptions {
      display: none;
    }
    .MuiAutocomplete-popper {
      background: transparent;
      .MuiAutocomplete-listbox {
        overflow: visible;
        max-height: none;
        padding: 0;
        .MuiAutocomplete-option p {
          line-height: ${theme.fonts['lineHeightM']};
          font-weight: ${theme.fonts['fontWeightMedium']};
        }
      }
      .MuiAutocomplete-paper {
        margin: ${toRem(0)} ${toRem(-24)};
        overflow: visible;
        @media ${theme.mediaQuery.desktop} {
          margin-left: ${toRem(-32)};
          margin-right: ${toRem(-32)};
        }
        @media ${theme.mediaQuery.largeDesktop} {
          margin-left: ${toRem(-40)};
          margin-right: ${toRem(-40)};
        }
        @media ${theme.mediaQuery.mobileOnly} {
          margin-top: ${toRem(20)};
          margin-bottom: ${toRem(4)};
          background: transparent;
        }
      }
      .MuiAutocomplete-option {
        padding: ${toRem(12)} ${toRem(40)} ${toRem(12)} ${toRem(24)};
        overflow-wrap: break-word;
        display: block;
        &:first-child {
          margin-top: ${toRem(16)};
        }
        &:last-child {
          margin-bottom: ${toRem(16)};
        }
        @media ${theme.mediaQuery.mobileOnly} {
          white-space: normal;
          padding: ${toRem(16)} ${toRem(16)};
        }
        @media ${theme.mediaQuery.desktop} {
          padding-left: ${toRem(32)};
          padding-right: ${toRem(32)};
        }
        @media ${theme.mediaQuery.largeDesktop} {
          padding-left: ${toRem(40)};
          padding-right: ${toRem(40)};
        }
        font-family: ${theme.fontFamily.swiss};
        font-size: ${toRem(16)};
        line-height: ${toRem(20)};
        p {
          margin: 0;
        }
        span {
          color: ${theme.color['dark-gray-13']};
        }
      }
      > div {
        box-shadow: none;
      }
    }

    /* mobile black sticky bar style */
    @media ${theme.mediaQuery.mobileOnly} {
      .MuiInput-underline::after {
        border: 0;
      }

      .MuiAutocomplete-inputRoot[class*='MuiInput-root'] {
        padding-bottom: 0;
        padding-right: ${toRem(40)};
        color: ${theme.color.white};
      }

      .MuiAutocomplete-popper {
        padding: 0 ${toRem(24)};
        width: 100% !important;
        position: absolute;
        top: ${toRem(109)};
        left: 0;
      }
      .MuiAutocomplete-endAdornment {
        right: ${toRem(6)};
        top: calc(50% - 11px);
      }
      .MuiIconButton-root,
      .MuiIconButton-root:hover {
        color: ${theme.color['dark-gray-1']};
        padding: 0;
        span {
          &:before {
            font-size: ${toRem(20)};
            margin-top: ${toRem(3)};
            color: ${theme.color['white']};
          }
        }
      }
      .MuiSvgIcon-root {
        height: ${toRem(13)};
        width: ${toRem(13)};
      }
    }
  }
`}
`;
